module.exports = __webpack_public_path__ + "img/blog_menu_pic10.47b117b2.png";